module.exports = __webpack_public_path__ + "img/header-memoireRingsRingsets.e8cacc9.webp";